import { Injectable } from '@angular/core';
import { Customer } from '../../shared/models/customer.model';

@Injectable({
  providedIn: 'root', // singleton across the app
})
export class CustomerService {
  private customerData: Customer | null = null;

  // Save customer info
  setCustomer(data: Customer): void {
    this.customerData = data;
    localStorage.setItem('customer', JSON.stringify(data));
  }

  // Retrieve customer info
  getCustomer(): Customer | null {
    if (this.customerData) {
      return this.customerData;
    }

    const stored = localStorage.getItem('customer');

    if (!stored) {
      this.customerData = null;
      return null;
    }

    try {
      this.customerData = JSON.parse(stored) as Customer;
    } catch {
      this.customerData = null;
      localStorage.removeItem('customer');
    }

    return this.customerData;
  }

  // Clear customer info
  clear(): void {
    this.customerData = null;
    localStorage.removeItem('customer');
  }
}